import { io } from 'socket.io-client';
import { baseURL } from '../Config';

// Initialize Socket.io connection
const socket = io(baseURL); // Replace with your backend's URL

export const getSocket = () => {
    if (!socket) {
        socket = io(baseURL, {
            reconnection: true, // Enables auto-reconnection
        });

        // Handle connection events
        socket.on('connect', () => {
            console.log('Socket connected:', socket?.id);
        });

        socket.on('disconnect', () => {
            console.log('Socket disconnected');
        });
    }

    return socket;
};

// Socket Constants
export const SOCKET_ENDPOINTS = {
    TICKET_CHAT: "ticketChat",
    NEW_SUPPORT_MESSAGE: "newSupportMessage",
    CANCEL_REQUEST_BY_PASSENGER: "cancelRequestByPassenger",
    CANCEL_ROUTE: "cancelRoute",
    ACTIVE_RIDE: "activeRide",
    START: "start",
    DELETE_ROUTE: "deleteRoute",
    DELETE_SCHEDULE: "deteleSchedule",
    ON_THE_WAY: "onTheWay",
    CANCEL_IN_RIDE_PASSENGER_REQUEST_BY_DRIVER: "cancelInRidePassengerRequestByDriver",
    ARRIVED: "arrived",
    REFRESH_LIVE_LOCATION: "refreshLiveLocation",
    REFRESH_DRIVER_ROUTES: "refreshDriverRoutes",
    PASSENGER_RIDE_CANCELLATION_LISTENER: "passengerRideCancellationListener",
    NEW_REQUEST: "newRequest",
    ACCEPT_REQUEST: "acceptRequest",
    REJECT_REQUEST_BY_DRIVER: "rejectRequestByDriver",
    ACCEPT_REQUEST_BY_PASSENGER: "acceptRequestByPassenger",
    REJECTED_REQUEST_BY_PASSENGER: "rejectedRequestByPassenger",
    SEND_REQUEST_TO_PASSENGER: "sendRequestToPassenger",
    RIDE_REQUEST: "rideRequest",
    START_RIDE: "startRide",
    PENDING_PAYMENT: "pendingPayment",
};

// Socket Constants
const SocketPoint = {
    // Passengers
    matchDriversEmit: "matcheddrivers",
    rideRequestToDriverEmit: "rideRequest",
    rejectRequestOfDriverEmit: "rejectedRequestByPassenger",
    cancelPassengerScheduleEmit: "cancelRequestByPassenger",
    inRidePassengerScheduleEmit: "cancelInRideRequestByPassenger",
    refreshEverything: "refresh",
    deteleSchedule: "deteleSchedule",
    driverLocationUpdatesOn: "refreshLiveLocation",
    updatePassengerRideStatus: "updatePassengerRideStatus",
    redirectPassengerToActiveRideListener: "redirectPassengerToActiveRide",
    refreshPassengerScheduleListener: "refreshSchedule",
    passengerRideCancellationListener: "passengerRideCancellationListener",
    driverCompleteRideListener: "driverCompleteRide",
    passengerActiveRideEmitter: "activeRide",
    confirmStartRide: "confirmStartRide",

    // Drivers
    startContinueRideByDriver: "start",
    driverNewRequestOn: "newRequest",
    requestedPassengersEmit: "getAllRequests",
    rejectRequestByDriver: "rejectRequestByDriver",
    cancelPassengerRideByDriver: "cancelRequestByDriver",
    acceptRequestByDriver: "acceptRequest",
    acceptRequestByPassenger: "acceptRequestByPassenger",
    updateDriverLocation: "liveLocation",
    cancelDriverRouteEmit: "cancelRoute",
    deleteDriverRouteEmit: "deleteRoute",
    finishDriverActiveRideEmit: "finishRide",
    onTheWayEmitter: "onTheWay",
    arrivedEmitter: "arrived",
    startRideEmitter: "startRide",
    pendingPaymentRideEmitter: "pendingPayment",
    completeRideEmitter: "completeRide",
    acceptInRideRequestEmit: "acceptInRideRequest",
    rejectInRideRequestEmit: "rejectInRideRequest",
    inRideRequestListener: "inRideRequest",
    rideConfirmationByPassengerListener: "rideConfirmByPassenger",
    cancelInRidePassengerRequestByDriver: "cancelInRidePassengerRequestByDriver",
    sendRequestToPassengerByDriver: "sendRequestToPassenger",
    rejectRequestOfPassengerByDriver: "",

    // Generic
    errorListener: "error",

    // Chats
    newMessageReceivedListener: "newMessageReceived",
    joinRoomAndGetMessagesEmitter: "chat",
    leaveRoomEmitter: "leaveChatRoom",
    sendMessageEmitter: "sendMessage",
    newMessageListener: "newMessage",
    deviceUpdatesListener: "deviceUpdate",

    // Others
    refreshDashboardListener: "refreshDashboard",
    newTicketEmitter: "newTicket",
    getChatsEmitter: "ticketChat",
    getUsersTicketsEmitter: "userTickets",
    newSupportMessage: "newSupportMessage",
    newSupportAttachment: "newSupportAttachments",
    uploadSupportAttachmentsEmitter: "uploadSupportAttachments",
    driverDocumentStatusEmitter: "documentsStatus",
};

// Socket Emitters
export const emitSocketEvent = (eventName, data) => {
    socket.emit(eventName, data, (response) => {
        console.log(`Response from ${eventName}:`, response);
    });
};

// Socket Listeners
export const addSocketListener = (eventName, callback) => {
    socket.on(eventName, (data) => {
        console.log(`Data received from ${eventName}:`, data);
        callback(data);
    });
};

// Remove Socket Listener
export const removeSocketListener = (eventName) => {
    socket.off(eventName);
};

// Example Usage
export const initializeSocketListeners = () => {
    addSocketListener(SocketPoint.newMessageListener, (message) => {
        console.log("New message received:", message);
    });

    addSocketListener(SocketPoint.refreshDashboardListener, (data) => {
        console.log("Dashboard refreshed:", data);
    });
};

export default SocketPoint;
